import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import novi__asset from "@/assets/restore/locations/novi.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Novi",
    serviceArea: "novi",
    address: "39555 Orchard Hill Place, Suite 600",
    img: novi__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=39555+Orchard+Hill+Place+Novi+MI",
    to: "/locations/michigan/novi/",
  },
];

export const Route = createFileRoute("/locations/michigan/")({
  head: () => ({
    meta: [
      { title: "Michigan Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Michigan. Book a free personal hair loss consultation at our Novi location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Michigan Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Novi, Michigan and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/michigan/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/michigan/" }],
  }),
  component: () => <StateLocationsHub stateName="Michigan" cities={cities} />,
});